import { Navigate, useSearchParams } from 'react-router-dom'
import { ProtectedProjectRoute, ProtectedWorkspaceRoute } from './guards'
import { PERMISSIONS } from '@/lib/permissions'

/**
 * Settings route wrapper that redirects to workspace settings if no project is selected,
 * otherwise shows project settings.
 */
export function SettingsRouteWrapper({
    projectComponent: ProjectComponent,
    workspaceRedirectPath = '/settings/workspace-settings'
}) {
    const [searchParams] = useSearchParams()
    const project = searchParams.get('project')
    const workspace = searchParams.get('workspace')

    if (!project) {
        // No project selected - redirect to workspace settings
        const redirectTo = workspace
            ? `${workspaceRedirectPath}?workspace=${workspace}`
            : workspaceRedirectPath
        return <Navigate to={redirectTo} replace />
    }

    // Project is selected - render project settings with guard
    return (
        <ProtectedProjectRoute permission={PERMISSIONS.PROJECT_SETTINGS_READ}>
            <ProjectComponent />
        </ProtectedProjectRoute>
    )
}
